export default __webpack_public_path__ + "media/Crucible_tablet.61730559efb2ddb302856de0aca17c71.svg";